var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('div',{staticClass:"dashboard"},[_vm._v("\n    Store\n  ")]),_c('div',[(!_vm.loading)?_c('button',{staticClass:"dark-button",on:{"click":_vm.updateStores}},[_vm._v("\n      Get new stores\n    ")]):_c('div',[_vm._v("\n      Getting Orders...\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }